"use client";

import { QueryResponseInitial, useQuery } from "@sanity/react-loader";
import { SanityDocument } from "next-sanity";

import { productsBySlugQuery } from '@otomoro/sanity/lib/queries/products/productsBySlug.groq'
import ProductPage from "./ProductPage";

export default function ProductPagePreview({
  initial,
	slug,
}: {
  initial: QueryResponseInitial<SanityDocument[]>;
	slug: string
}) {
	const { data } = useQuery<SanityDocument[] | null>(
    productsBySlugQuery,
    {
			slug
		},
    { initial }
  );

	return data ? (
    <ProductPage data={data as any} />
  ) : (
    <div className="bg-red-100">No posts found</div>
  );
}
